import { DensityType } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { useField, useFormikContext } from 'formik'
import { useCallback, useMemo } from 'react'
import { ISalesFunnel } from '@user/store/salesFunnel'

import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import { LeadAssignmentRuleFormModel } from '../../../../typings'

type Props = {
  name: string
  salesFunnels: ISalesFunnel[]
  required?: boolean
}

export function useData(props: Props) {
  const { name, salesFunnels, required } = props
  const tidalThemeActive = useTidalThemeActive()

  const {
    isSubmitting,
    values: { salesFunnelId },
  } = useFormikContext<LeadAssignmentRuleFormModel>()

  const [, { error, touched }] = useField<string[]>({
    name,
    validate: (value) => {
      if (required !== undefined ? required : !value) {
        return 'Required'
      }
    },
  })

  const showError =
    required !== undefined
      ? Boolean(required && error && touched)
      : Boolean(error && touched)
  const helperText = showError ? error : ''

  const options = salesFunnels

  const getLabel = useCallback(
    (option: ISalesFunnel) =>
      option.isDefault ? `(Default) ${option?.name}` : option?.name,
    [],
  )

  const getId = useCallback((option: ISalesFunnel) => {
    return String(option.id)
  }, [])

  const selectedOption = useMemo(() => {
    if (salesFunnelId) {
      const value = salesFunnels.find((x) => x.id == salesFunnelId)

      if (value) return value
    }

    return null
  }, [salesFunnels, salesFunnelId])

  const density: DensityType = tidalThemeActive ? 'comfortable' : 'compact'

  return {
    getLabel,
    getId,
    items: options,
    selectedOption,
    isSubmitting,
    showError,
    helperText,
    density,
    salesFunnelId,
  }
}
